export const CREATE_ACCOUNT_FORM_VALUES = {
  EMAIL: {
    ID: 'email',
    PLACEHOLDER: 'Please enter email',
    LABEL: 'Email',
  },
}
